export const state = () => ({
  loading: false,
  searchQuery: null,
  sortBy: 'nearest',
  filterPropertyType: null,
  filterPeriodStart: null,
  filterListingType: null,
  filterProvince: null,
  filterCity: null,
  filterArea: null,
  page: 1,
  recommendedListings: [],
  meta: null,
  availabilities: [],
  selectedAvailabilities: [],
  province: null,
  city: null,
  area: null,
  propertyType: null,
  listingType: null,
  listing: null,
  coinCost: 0,
});

export const getters = {
  formattedRecommendedListings(state) {
    // if (state.featuredAgents && state.featuredAgents.length > 0) {
    //   const grouped = state.featuredAgents.reduce((acc, curr) => {
    //     const key = curr.area_id; // group by area_id (and area is assumed to be same for same id)
    //     if (!acc[key]) {
    //       acc[key] = {
    //         area_id: curr.area_id,
    //         area: curr.area,
    //         entries: [],
    //       };
    //     }
    //     // Destructure the properties needed for the entry
    //     const { uuid, month_name, month, year } = curr;
    //     acc[key].entries.push({ uuid, month_name, month, year });
    //     return acc;
    //   }, {});
    //
    //   // Sort entries by year and month in ascending order
    //   return Object.values(grouped).map((group) => {
    //     group.entries.sort((a, b) => a.year - b.year || a.month - b.month);
    //     return group;
    //   });
    // }

    return state.recommendedListings;
  },
};

export const mutations = {
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_SEARCH_QUERY(state, payload) {
    state.searchQuery = payload;
  },
  SET_SORT_BY(state, payload) {
    state.sortBy = payload;
  },
  SET_FILTER_PROPERTY_TYPE(state, payload) {
    state.filterPropertyType = payload;
  },
  SET_FILTER_PERIOD_START(state, payload) {
    state.filterPeriodStart = payload;
  },
  SET_FILTER_LISTING_TYPE(state, payload) {
    state.filterListingType = payload;
  },
  SET_FILTER_PROVINCE(state, payload) {
    state.filterProvince = payload;
  },
  SET_FILTER_CITY(state, payload) {
    state.filterCity = payload;
  },
  SET_FILTER_AREA(state, payload) {
    state.filterArea = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_RECOMMENDED_LISTINGS(state, payload) {
    state.recommendedListings = payload;
  },
  SET_META(state, payload) {
    state.meta = payload;
  },
  SET_AVAILABILITIES(state, payload) {
    state.availabilities = payload;
  },
  SET_SELECTED_AVAILABILITIES(state, payload) {
    state.selectedAvailabilities = payload;
  },
  SET_PROVINCE(state, payload) {
    state.province = payload;
  },
  SET_CITY(state, payload) {
    state.city = payload;
  },
  SET_AREA(state, payload) {
    state.area = payload;
  },
  SET_PROPERTY_TYPE(state, payload) {
    state.propertyType = payload;
  },
  SET_LISTING_TYPE(state, payload) {
    state.listingType = payload;
  },
  SET_LISTING(state, payload) {
    state.listing = payload;
  },
  SET_COIN_COST(state, payload) {
    state.coinCost = payload;
  },
};

export const actions = {
  restoreInitialState({ commit }) {
    commit('SET_SEARCH_QUERY', null);
    commit('SET_SORT_BY', 'nearest');
    commit('SET_FILTER_PROPERTY_TYPE', null);
    commit('SET_FILTER_PERIOD_START', null);
    commit('SET_FILTER_LISTING_TYPE', null);
    commit('SET_FILTER_PROVINCE', null);
    commit('SET_FILTER_CITY', null);
    commit('SET_FILTER_AREA', null);
    commit('SET_PAGE', 1);
    commit('SET_RECOMMENDED_LISTINGS', []);
    commit('SET_META', null);
    commit('SET_AVAILABILITIES', []);
    commit('SET_SELECTED_AVAILABILITIES', []);
    commit('SET_PROVINCE', null);
    commit('SET_CITY', null);
    commit('SET_AREA', null);
    commit('SET_PROPERTY_TYPE', null);
    commit('SET_LISTING_TYPE', null);
    commit('SET_LISTING', null);
    commit('SET_COIN_COST', null);
  },
  async getRecommendedListings({ state, commit }, { page, useLoading = true }) {
    try {
      commit('SET_LOADING', useLoading);
      if (page) {
        commit('SET_PAGE', page);
      }
      let { data } = await this.$http.get('/api/listing_boosts/recommended/', {
        params: {
          page: state.page,
          per_page: 30,
          q: state.searchQuery,
          sort: state.sortBy,
          property_type_id: state.filterPropertyType?.id,
          period_start: state.filterPeriodStart?.value,
          listing_type: state.filterListingType?.value,
          province_id: state.filterProvince?.id,
          city_id: state.filterCity?.id,
          area_id: state.filterArea?.id,
        },
      });

      const result = data.data;
      commit('SET_RECOMMENDED_LISTINGS', result);
      // commit('SET_META', result.meta);
      return result;
    } catch (e) {
      throw e;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async getForm({ commit }, listingUuid) {
    try {
      commit('SET_LOADING', true);
      let { data } = await this.$http.get('/api/listing_boosts/recommended/get_form', {
        params: {
          uuid: listingUuid,
        },
      });

      const result = data.data;
      commit(
        'SET_AVAILABILITIES',
        result?.availabilities?.map((item) => ({
          ...item,
          uuid: crypto.randomUUID(),
        })) ?? [],
      );
      commit('SET_SELECTED_AVAILABILITIES', []);
      commit('SET_PROVINCE', result.province);
      commit('SET_CITY', result.city);
      commit('SET_AREA', result.area);
      commit('SET_PROPERTY_TYPE', result.property_type);
      commit('SET_LISTING_TYPE', result.listing_type);
      commit('SET_LISTING', result.listing);
      commit('SET_COIN_COST', result.coin_cost);
      return result;
    } catch (e) {
      throw e;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async purchase({ state, commit }, listingUuid) {
    try {
      commit('SET_LOADING', true);
      return await this.$http.post('/api/listing_boosts/recommended/purchase', {
        listing_uuid: listingUuid,
        availabilities: state.selectedAvailabilities.map((availability) => availability.start_date),
      });
    } catch (e) {
      throw e;
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async changeRecommended({ commit }, { listingUuid, boostUuid }) {
    try {
      commit('SET_LOADING', true);
      return await this.$http.post('/api/listing_boosts/recommended/change_listing', {
        listing_uuid: listingUuid,
        boost_uuid: boostUuid,
      });
    } catch (e) {
      throw e;
    } finally {
      commit('SET_LOADING', false);
    }
  },
};
